(function () {
  'use strict';
  if (window.__pkrBoxen) return;
  window.__pkrBoxen = true;
  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var gesehen = window.IntersectionObserver && !ruhig ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      gesehen.unobserve(e.target);
      e.target.querySelectorAll('.pkr__punkt').forEach(function (p, i) {
        p.style.setProperty('--pkr-v', (i * 90) + 'ms');
        p.classList.add('is-da');
      });
    });
  }, { threshold: 0.2 }) : null;

  function punkteFuer(reihe) {
    var p = reihe.nextElementSibling;
    while (p && !p.hasAttribute('data-pkr-punkte')) p = p.nextElementSibling;
    return p;
  }
  function einrichten(reihe) {
    if (reihe.__pkrBox) return;
    reihe.__pkrBox = true;
    if (gesehen) { reihe.classList.add('is-bewegt'); gesehen.observe(reihe); }
    var boxen = reihe.querySelectorAll('.pkr__punkt');
    var punkte = punkteFuer(reihe);
    if (!punkte || boxen.length < 2) return;
    punkte.innerHTML = '';
    boxen.forEach(function () { punkte.appendChild(document.createElement('i')); });
    function markieren() {
      var links = reihe.getBoundingClientRect().left, best = 0, abst = Infinity;
      boxen.forEach(function (b, i) {
        var d = Math.abs(b.getBoundingClientRect().left - links - 16);
        if (d < abst) { abst = d; best = i; }
      });
      punkte.querySelectorAll('i').forEach(function (p, i) { p.classList.toggle('is-an', i === best); });
    }
    var t = null;
    reihe.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(markieren); }, { passive: true });
    markieren();
  }
  function start() { document.querySelectorAll('.pkr--boxen').forEach(einrichten); }
  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
